import { Box, Heading, Table, Tbody, Tr, Td, Text, useColorMode } from '@chakra-ui/react';

export const TopTablePercent = (props) => {
    const { colorMode } = useColorMode();
    const { title, data, ...boxProps } = props;

    const backgroundColor = colorMode === 'light' ? 'gray.30' : 'gray.700';

    // Check if data is null or undefined
    if (!data) {
        return <Box {...boxProps}>No data available.</Box>;
    }

    // Convert the data object into an array of {name, percent} objects
    const dataArray = Object.entries(data).map(([name, percent]) => ({
        name,
        percent
    }));

    // Check if dataArray is empty
    if (dataArray.length === 0) {
        return <Box {...boxProps}>Data is empty.</Box>;
    }

    return (
        <Box bg={backgroundColor} rounded='10px' boxShadow="md" {...boxProps}>
            <Box
                px={{
                    base: '4',
                    md: '6',
                }}
                py={{
                    base: '5',
                    md: '6',
                }}
            >
                <Heading
                    size={{
                        base: 'lg',
                        md: 'lg',
                    }}
                    mb="4"
                >
                    {title}
                </Heading>
                <Table variant="simple">
                    <Tbody>
                        {dataArray.map((item, index) => (
                            <Tr key={index}>
                                <Td><Text fontSize='2xl'>{item.name}</Text></Td>
                                <Td><Text fontSize='2xl'>{`${item.percent.toFixed(2)}%`}</Text></Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
        </Box>
    );
}
